import { useCallback } from 'react';
import { useInvalidateAndRefetch } from 'src/graphql/setup/hooks/use-invalidate-and-refetch';
import { queryRegistry } from 'src/graphql/setup/query-registry';
import { ConditionInput } from 'src/graphql/types';

export function useInvalidateSiteConversations(): (addressId: string) => void {
  const invalidateAndRefetch = useInvalidateAndRefetch();

  return useCallback(
    (addressId: string) => {
      queryRegistry.getQueriesForEntity('Conversation').forEach((query) => {
        const filters: ConditionInput[] = query.variables.params?.filters ?? [];

        const scopedToSite = filters.some(
          (filter) =>
            filter.attribute === 'associatedAddresses/addressId' &&
            String(filter.value).split(',').includes(String(addressId)),
        );

        if (scopedToSite) {
          invalidateAndRefetch({
            hashKey: query.key,
            operationName: query.operationName,
            variables: query.variables as Record<string, unknown>,
            query: query.query,
          });
        }
      });
    },
    [invalidateAndRefetch],
  );
}
